import React from 'react'
import { DecryptedForm, DecryptedPatient } from '@icure/cardinal-sdk'
import { formatTimestampToHumanReadable } from '../../../../../helpers/date'
import './index.less'
import { Button } from 'antd'
import { pencilIcn } from '../../../../../assets/CustomIcons'
import Icon from '@ant-design/icons'
import { createPortal } from 'react-dom'
import { ModalAddConsultationForm } from '../../ModalAddConsultationForm'

type ConsultationProps = {
  form: DecryptedForm
  patient: DecryptedPatient
}

export const Consultation = ({ form, patient }: ConsultationProps) => {
  const [isAddConsultationModalOpen, setAddConsultationModalOpen] = React.useState(false)

  const handleEdit = () => {
    setAddConsultationModalOpen(true)
  }
  return (
    <div className="consultation">
      <div className="consultation__item">
        <h5>Date of visit:</h5>
        <p>{formatTimestampToHumanReadable(form.openingDate)}</p>
      </div>
      <Button onClick={() => handleEdit()}>
        <Icon component={pencilIcn} />
        Edit
      </Button>
      {isAddConsultationModalOpen &&
        createPortal(
          <ModalAddConsultationForm initialRootFormId={form.id} isVisible={isAddConsultationModalOpen} onClose={() => setAddConsultationModalOpen(false)} patient={patient} />,
          document.body,
        )}
    </div>
  )
}
